import React from 'react'
import { checkTextTranslation, getObject, imageAddress } from '../../utils/useful'

class TableImageInput extends React.Component {
  state = {
  }

  componentDidMount() {
    // console.log('this.proopsasfesd', this.props)
    this.init()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.init()
    }
  }

  init() {
    let data = this.props.data
    let output = data
    if (typeof data == 'string' && /\{\{(.*?)\}\}/.test(data)) {
      let reg = new RegExp('\{\{(.*?)\}\}', 'g')
      // console.log("TEST!!")
      let matches = data.match(reg)

      if (matches && matches.length > 0) {
        for (let index = 0; index < matches.length; index++) {
          const match = matches[index];

          // console.log("here!!!")
          let key = match.replace(/{/g, '').replace(/}/g, '')

          // console.log(matches)
          // console.log(key)

          if (this.props.headers) {
            for (let j = 0; j < this.props.headers.length; j++) {
              const header = this.props.headers[j];

              // console.log(header?.key)
              // console.log(header?.type)

              if (((key == header.information?.label || key == header.key || ('values.' + key) == (header.key))) && header.type == 'ImageInput') {
                let value = getObject(this.props.fullData, header.key)
                // console.log(value)
                // let nreg = new RegExp(match, 'g')
                output = value
              }
            }
          }
        }
        if (/\{\{(.*?)\}\}/.test(output)) {
          output = null
        }
      }
    } else if (data == '**custom') {
      output = this.props.header?.information?.address
    }



    this.setState({ data: output })

  }


  changeInputValue(target) {
    let value = (target.validity.valid) ? target.value : null
    if (value !== null) {
      this.props.changeValue(this.props.header.key, value)
    }
  }


  renderImage(image, index, margin, local) {
    // let styleInfo = this.props.styleInfo
    let mimageAddress = imageAddress(image, "mini", 'small')

    let styleInfo = this.props.header.information?.style
    // if (local) {
    //   mimageAddress = imageAddress(null)
    // }

    // console.log(styleInfo)
    // console.log((styleInfo?.width ? (styleInfo?.width + (styleInfo?.widthUnit ?? '%')) : '100%'))
    // console.log(mimageAddress)

    if (styleInfo) {
      return (
        <img key={index} src={mimageAddress} style={{ width: (styleInfo?.width ? (styleInfo?.width + (styleInfo?.widthUnit ?? '%')) : '100%'), maxWidth: 400, borderRadius: styleInfo?.borderRadius ?? 10, objectFit: 'cover' }} />
      )
    } else {
      return (
        <img key={index} src={mimageAddress} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: margin ? 2 : null }} />
      )
    }
  }


  render() {

    // let header = this.props.header
    // let data = this.state.data
    // console.log(data)

    let styleInfo = this.props.header.information?.style
    let justifyContent = styleInfo?.align

    return (

      <div className="text-center d-flex  w-100" style={{ overflow: 'auto', justifyContent: justifyContent ?? 'center' }}>
        {Array.isArray(this.props.data) && this.props.data.map((image, index) => {
          // console.log(image)
          return (
            this.renderImage(image, index, true)
            // <img key={index} src={imageAddress(image, "mini", 'mini')} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: 2 }} />
          )
        })
        }

        {!Array.isArray(this.props.data) && this.state.data && (
          this.renderImage(this.state.data)
          // <img src={imageAddress(this.state.data, "mini", "mini")} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover' }} />
        )}

        {!this.state.data && (
          this.renderImage(null, null, null, true)
        )}

      </div>

      // <div className="w-100 h-100">
      //     <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data}</p>
      // </div>
    )
  }
}

export default TableImageInput;